import { throttle } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';

/**
 * This modal is configured to be only used by Pages and Blog publish actions
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PatagoniaBasePublishConfirmModal = ({
  headerLangKey,
  primaryButtonKey,
  secondaryButtonKey,
  children,
  primaryButtonDisabled,
  primaryButtonDisabledTooltip,
  afterCloseCallback,
  primaryCallback,
  secondaryCallback
}) => {
  const throttledPrimaryCallback = throttle(primaryCallback, 1000, {
    trailing: false
  });
  const throttledSecondaryCallback = throttle(secondaryCallback, 1000, {
    trailing: false
  });
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 550,
    "data-selenium": "confirm-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: afterCloseCallback
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: headerLangKey
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: children
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(UITooltip, {
          disabled: !primaryButtonDisabled,
          title: primaryButtonDisabledTooltip,
          children: /*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "publish-confirm-button",
            "data-onboarding": "publish-confirm-button",
            use: "primary",
            disabled: primaryButtonDisabled,
            onClick: throttledPrimaryCallback,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: primaryButtonKey
            })
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "publish-confirm-secondary-button",
          use: "secondary",
          onClick: throttledSecondaryCallback,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: secondaryButtonKey
          })
        })]
      })
    })]
  });
};
export default PatagoniaBasePublishConfirmModal;